module.exports = __webpack_public_path__ + "img/gel.ea98e0e6.png";